import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const BolListPage = loadable(
  async () => import("~/features/bol/pages/BolListPage"),
  { fallback: <></> },
)

const BolDetailsLayout = loadable(
  async () => import("~/features/bol/pages/BolDetailsLayout"),
  { fallback: <></> },
)

const BolDetailsPage = loadable(
  async () => import("~/features/bol/pages/BolDetailsPage"),
  { fallback: <></> },
)

const CreateBolPage = loadable(
  async () => import("~/features/bol/pages/CreateBolPage"),
  { fallback: <></> },
)

const CreateNewBolPage = loadable(
  async () => import("~/features/bol/pages/CreateNewBolPage"),
  { fallback: <></> },
)

export const bolRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.bols,
    element: <BolListPage />,
    children: [
      {
        path: ":BOLId",
        element: <BolDetailsLayout />,
        children: [{ index: true, element: <BolDetailsPage /> }],
      },
    ],
  },
  {
    path: APP_ROUTES.createBol,
    element: <CreateBolPage />,
  },
  {
    path: APP_ROUTES.createNewBol,
    element: <CreateNewBolPage />,
  },
]
